import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-actions',
  templateUrl: './modal-actions.component.html',
  styleUrls: ['./modal-actions.component.scss']
})
export class ModalActionsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
